<template>
  <div class="content-warp">
    <div class="content-panle bg-white">
      <div class="table-operation-area">
        <div class="btn-area-inline">
          <TableTips :total="pagination.total"/>
        </div>
        <a-form class="search-form" layout="inline" :form="listSearchForm" @submit.prevent="handleSearchList">
          <a-form-item>
            <a-range-picker
              style="width: 350px"
              format="YYYY-MM-DD"
              :placeholder="[$t('visitorMana.record.authorizedStartTimeTxt'), $t('visitorMana.record.authorizedEndTimeTxt')]"
              :ranges="searchDateRangesBtn"
              v-decorator="['dateRange', {initialValue: [moment().subtract(1,'month'), moment()]}]"
            />
          </a-form-item>

          <a-form-item>
            <a-tree-select
              style="width: 180px"
              :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
              :placeholder="$t('visitorMana.record.visitorOrgTxt')"
              :treeData="orgTreeDownSelectionData"
              :treeDefaultExpandedKeys="[orgTreeDownSelectionData[0].value]"
              v-decorator="['deptId', {initialValue: orgTreeDownSelectionData[0].value}]"
            />
          </a-form-item>

          <a-form-item>
            <a-input
              style="width: 180px"
              type="text"
              v-decorator="['name']"
              :placeholder="$t('visitorMana.record.visitorOrInviterName')">
              <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
            </a-input>
          </a-form-item>

          <a-form-item style="margin-right:0">
            <a-button type="primary" html-type="submit" style="margin-right: 10px" :loading="loading">
              {{ $t('visitorMana.record.searchBtn') }}
            </a-button>
            <a-button type="primary" :loading="exportLoading" @click="handleExportList">
              {{ $t('visitorMana.record.exportBtn') }}
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <a-table
        style="min-height: 584px"
        :columns="tableColumns"
        :dataSource="tableData"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :scroll="tableData.length?{ x: 1900 }:{}"
      >
        <span slot="reserved" slot-scope="text, record">
          <a-tag v-if="!text" color="red">{{ $t('visitorMana.record.listNo') }}</a-tag>
          <a-tag v-else color="green">{{ $t('visitorMana.record.listYes') }}</a-tag>
        </span>
        <template slot="operation" slot-scope="text, record">
          <a
            class="operation-botton"
            :disabled="record.operation.disabled"
            @click="record.operation.callback(record)"
          >
            {{ $t(record.operation.type) }}
          </a>
        </template>
      </a-table>
    </div>

    <!-- 访客详情 -->
    <a-modal
      :title="$t('visitorMana.record.modalVisitedRecordDetail')"
      :visible="detailModalVisible"
      :footer="null"
      width="900px"
      @cancel="()=>{detailModalVisible=false}"
      :afterClose="handleDetailModalHide"
      :bodyStyle="{ maxHeight: '700px',overflowY: 'auto' }"
    >
      <div v-if="detailModalLoading" class="loading-spin-warp">
        <a-spin tip="Loading..." class="loading-spin"></a-spin>
      </div>
      <div class="content-panle padding-0">
        <!-- 访客信息 -->
        <h3 class="panle-head" style="margin-bottom: 24px">{{ $t('visitorMana.record.mVisitorTitle') }}</h3>
        <a-row :gutter="20" type="flex" justify="start" align="middle">
          <!-- 预约现场照 -->
          <!-- <a-col :span="4" class="desc-image-warp">
            <div class="image-content">
              <img v-if="!reservedPhotoUrl" src="../../../public/empty_person.png" :alt="$t('visitorMana.record.mReservedPhoto')">
              <img v-else :src="reservedPhotoUrl" :alt="$t('visitorMana.record.mReservedPhoto')">
            </div>
            <span class="image-title">{{$t('visitorMana.record.mReservedPhoto')}}</span>
          </a-col> -->
          <!-- 到访签到照 -->
          <a-col :span="6" class="desc-image-warp">
            <div class="image-content">
              <img v-if="!signInPhotoUrl" src="../../../public/empty_person.png"
                   :alt="$t('visitorMana.record.mSignInPhoto')">
              <img v-else :src="signInPhotoUrl" :alt="$t('visitorMana.record.mSignInPhoto')">
            </div>
            <span class="image-title">{{ $t('visitorMana.record.mSignInPhoto') }}</span>
          </a-col>
          <a-col :span="18" class="padding-0">
            <!-- 访客姓名 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{ $t('visitorMana.record.mName') }}</span>
              <span class="desc-content">{{ vName }}</span>
            </a-col>
            <!-- 手机号码 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{ $t('visitorMana.record.mPhone') }}</span>
              <span class="desc-content">{{ vPhone }}</span>
            </a-col>
            <!-- 证件类型 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{ $t('visitorMana.record.mCardType') }}</span>
              <span class="desc-content">{{ vCardType }}</span>
            </a-col>
            <!-- 车牌号 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{ $t('visitorMana.record.mLicense') }}</span>
              <span class="desc-content">{{ vLicense }}</span>
            </a-col>
            <!-- 证件号码 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{ $t('visitorMana.record.mIDNumber') }}</span>
              <span class="desc-content">{{ vIDNumber }}</span>
            </a-col>
            <!-- 是否为预约人员 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{ $t('visitorMana.record.mIsReserved') }}</span>
              <span class="desc-content">
                <a-tag v-if="!vReserved" color="red">{{ $t('visitorMana.record.mNo') }}</a-tag>
                <a-tag v-else color="green">{{ $t('visitorMana.record.mYes') }}</a-tag>
              </span>
            </a-col>
            <!-- 签到时间 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{ $t('visitorMana.record.mSignInAt') }}</span>
              <span class="desc-content">{{ vSignInAt }}</span>
            </a-col>
            <!-- 签到设备 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{ $t('visitorMana.record.mSignInDevice') }}</span>
              <span class="desc-content">{{ vSignInDevice }}</span>
            </a-col>
            <!-- 签离时间 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{ $t('visitorMana.record.mSignOutAt') }}</span>
              <span class="desc-content">{{ vSignOutAt }}</span>
            </a-col>
            <!-- 签离设备 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{ $t('visitorMana.record.mSignOutDevice') }}</span>
              <span class="desc-content">{{ vSignOutDevice }}</span>
            </a-col>
          </a-col>
        </a-row>

        <!-- 被访问相关信息 -->
        <h3 class="panle-head" style="margin-bottom: 24px">{{ $t('visitorMana.record.mBeVisitedInfoTitle') }}</h3>
        <a-row :gutter="20">
          <!-- 被访问人 -->
          <a-col :span="12" class="desc-text-warp">
            <span class="desc-title">{{ $t('visitorMana.record.mIName') }}</span>
            <span class="desc-content">{{ iName }}</span>
          </a-col>
          <!-- 被访问人组织 -->
          <a-col :span="12" class="desc-text-warp">
            <span class="desc-title">{{ $t('visitorMana.record.mIOrg') }}</span>
            <span class="desc-content">{{ iOrg }}</span>
          </a-col>
          <!-- 访问时间 -->
          <a-col :span="24" class="desc-text-warp">
            <span class="desc-title">{{ $t('visitorMana.record.mVisitRange') }}</span>
            <span class="desc-content">{{ visitRange }}</span>
          </a-col>
          <!-- 来访事由 -->
          <a-col :span="12" class="desc-text-warp">
            <span class="desc-title">{{ $t('visitorMana.record.mVisitReason') }}</span>
            <span class="desc-content">{{ visitReason }}</span>
          </a-col>
          <!-- 备注 -->
          <a-col :span="12" class="desc-text-warp">
            <span class="desc-title">{{ $t('visitorMana.record.mRemark') }}</span>
            <span class="desc-content">{{ remark }}</span>
          </a-col>
        </a-row>
        <!-- 预约扩展信息 -->
        <template v-if=" exFieldKeys.length > 0">
          <!-- 预约申请信息 -->
          <h3 class="panle-head" style="margin-bottom: 24px; margin-top:12px">扩展信息</h3>
          <a-row :gutter="20">
            <a-col :span="12" class="desc-text-warp" v-for="(key, index) in exFieldKeys" :key="index">
              <span class="desc-title">{{exFieldConfig[key].name}}</span>
              <span class="desc-content">{{  getExtValue(key) }}</span>
            </a-col>
          </a-row>
        </template>
        <!-- 同行到访人员 -->
        <h3 class="panle-head" style="margin-bottom: 24px; margin-top:12px">
          {{ $t('visitorMana.reserved.mCompanionTitle') }}
        </h3>
        <a-table
          class="empty-placeholder"
          v-if="!otherVisitor.length"
        ></a-table>
        <a-row
          :gutter="20"
          type="flex"
          justify="start"
          align="middle"
          v-for="(visitor, index) in otherVisitor"
          :key="index"
        >
          <!-- 预约现场照 -->
          <a-col :span="4" class="desc-image-warp">
            <div class="image-content">
              <img
                v-if="!visitor.reservedPhotoUrl"
                src="../../../public/empty_person.png"
                :alt="$t('visitorMana.reserved.mReservedPhoto')"
              />
              <img
                v-else
                :src="visitor.reservedPhotoUrl"
                :alt="$t('visitorMana.reserved.mReservedPhoto')"
              />
            </div>
            <span class="image-title">{{
                $t('visitorMana.reserved.mReservedPhoto')
              }}</span>
          </a-col>
          <!-- 到访签到照 -->
          <a-col :span="4" class="desc-image-warp">
            <div class="image-content">
              <img
                v-if="!visitor.signInPhotoUrl"
                src="../../../public/empty_person.png"
                :alt="$t('visitorMana.reserved.mSignInPhoto')"
              />
              <img
                v-else
                :src="visitor.signInPhotoUrl"
                :alt="$t('visitorMana.reserved.mSignInPhoto')"
              />
            </div>
            <span class="image-title">{{
                $t('visitorMana.reserved.mSignInPhoto')
              }}</span>
          </a-col>
          <a-col :span="16" class="padding-0">
            <!-- 访客姓名 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mName')
                }}</span>
              <span class="desc-content">{{ visitor.name }}</span>
            </a-col>
            <!-- 手机号码 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mPhone')
                }}</span>
              <span class="desc-content">{{ visitor.phone }}</span>
            </a-col>
            <!-- 证件类型 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mCardType')
                }}</span>
              <span class="desc-content">{{ visitor.cardType }}</span>
            </a-col>
            <!-- 车牌号 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mLicense')
                }}</span>
              <span class="desc-content">{{ visitor.license }}</span>
            </a-col>
            <!-- 证件号码 -->
            <a-col :span="24" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mIDNumber')
                }}</span>
              <span class="desc-content">{{ visitor.idNumber }}</span>
            </a-col>
            <!-- 签到时间 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignInAt')
                }}</span>
              <span class="desc-content">{{ visitor.signInAt }}</span>
            </a-col>
            <!-- 签到设备 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignInDevice')
                }}</span>
              <span class="desc-content">{{ visitor.signInDevice }}</span>
            </a-col>
            <!-- 签离时间 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignOutAt')
                }}</span>
              <span class="desc-content">{{ visitor.signOutAt }}</span>
            </a-col>
            <!-- 签离设备 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignOutDevice')
                }}</span>
              <span class="desc-content">{{ visitor.signOutDevice }}</span>
            </a-col>
          </a-col>
          <div
            v-if="index !== otherVisitor.length - 1"
            class="desc-bottom-line"
          ></div>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>

<script>
import TableTips from '@/components/TableTips'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import { getVisitorRecords, getVisitorApplyDetail, exportVisitorSearchList } from '@/api/visitorMana'
import { downLoadFileViaAjaxPost } from '../../utils/utils'
import { getUserConfig } from '../../api/userMana'

export default {
  name: 'visitorRecord',
  components: { TableTips },
  data() {
    return {
      listSearchForm: this.$form.createForm(this),

      searchDeptFullName: '',
      searchName: '',
      searchFromDate: moment().format('YYYY-MM-DD'),
      searchToDate: moment().format('YYYY-MM-DD'),
      // 有效期 date-range-picker
      searchDateRangesBtn: this.getSearchDateRangesBtn(),

      loading: false, // 列表内容是否在加载中
      exportLoading: false, // 列表内容是否在导出中
      tableData: [], // 列表数据源
      tableColumns: this.getTableColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      detailModalVisible: false,
      detailModalLoading: false,

      reservedPhotoUrl: '',
      signInPhotoUrl: '',
      vName: '',
      vPhone: '',
      vCardType: '',
      vLicense: '',
      vIDNumber: '',
      vSignInAt: '',
      vSignInDevice: '',
      vSignOutAt: '',
      vSignOutDevice: '',
      vReserved: '',

      iName: '',
      iOrg: '',
      visitRange: '',
      visitReason: '',
      remark: '',
      otherVisitor: [],

      exFieldConfig: {},
      exFieldValue: {},
      exFieldKeys: [],
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      enumsData: state => state.enumsStore.enumsData,
      orgTreeSourceData: state => state.orgStore.orgTreeSourceData
    }),
    ...mapGetters(['orgTreeDownSelectionData', 'orgAutoCompletedSourceData'])
  },
  watch: {
    lang: function (lang) {
      this.tableColumns = this.getTableColumns()
      this.searchDateRangesBtn = this.getSearchDateRangesBtn()
    }
  },
  created() {
    this.idType = {}
    this.enumsData.idType.forEach(item => {
      this.idType[item.value] = item.title
    })
    this.getSettings()
    this.handleSearchList()
  },
  methods: {
    moment,
    getTableColumns() {
      return [
        {
          title: this.$t('visitorMana.record.listVisitorName'),
          dataIndex: 'visitor',
          width: '100px'
          // width: 150
        },
        {
          title: this.$t('visitorMana.record.listVisitorPhone'),
          dataIndex: 'visitorPhone',
          width: '9%'
        },
        {
          title: this.$t('visitorMana.record.listLicensePlate'),
          dataIndex: 'carNumber',
          width: '9%'
        },
        {
          title: this.$t('visitorMana.record.listInterviewee'),
          dataIndex: 'interviewee',
          width: '9%'
        },
        {
          title: this.$t('visitorMana.record.listIntervieweeOrg'),
          dataIndex: 'deptFullName',
          width: '15%'
        },
        {
          title: this.$t('visitorMana.record.listAuthorizedTime'),
          dataIndex: 'expiryDate'
          // width: '17%'
        },
        {
          title: this.$t('visitorMana.record.listSignInTime'),
          dataIndex: 'signIn',
          width: '9%'
        },
        {
          title: this.$t('visitorMana.record.listSignOutTime'),
          dataIndex: 'signOut',
          width: '9%'
        },
        {
          title: this.$t('visitorMana.record.listReserved'),
          dataIndex: 'reserved',
          // width: '10%',
          width: '100px',
          fixed: 'right',
          scopedSlots: { customRender: 'reserved' }
        },
        {
          title: this.$t('visitorMana.record.listOperation'),
          dataIndex: 'operation',
          // width: '10%',
          width: '100px',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    // 获取时间段选择插件快捷按钮内容
    getSearchDateRangesBtn() {
      const btns = {}
      btns[this.$t('visitorMana.record.aWeekBeforeBtn')] = [this.moment().subtract(6, 'days'), this.moment()]
      btns[this.$t('visitorMana.record.oneMonthBeforeBtn')] = [this.moment().subtract(1, 'months'), this.moment()]
      btns[this.$t('visitorMana.record.threeMonthsBeforeBtn')] = [this.moment().subtract(3, 'months'), this.moment()]
      return btns
    },
    // 搜索列表
    handleSearchList() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          if (Object.keys(values).length > 0) {
            this.searchDeptFullName = this.orgAutoCompletedSourceData.find(org => org.id === values.deptId).name
            this.searchName = values.name
            this.searchFromDate = values.dateRange[0] ? values.dateRange[0].format('YYYY-MM-DD') : ''
            this.searchToDate = values.dateRange[1] ? values.dateRange[1].format('YYYY-MM-DD') : ''
          }
          this.pagination.current = 1
          this.getListData()
        }
      })
    },
    // 获取列表数据
    async getListData() {
      try {
        this.loading = true
        const res = await getVisitorRecords({
          beVisitedPersonDeptFullName: this.searchDeptFullName || this.orgTreeDownSelectionData[0].fullName,
          visitStartFrom: this.searchFromDate,
          visitStartTo: this.searchToDate,
          name: this.searchName,
          perPage: this.pagination.pageSize,
          page: this.pagination.current
        })
        this.loading = false
        this.tableData = this.createRecordTableData(res.data.collection)
        this.pagination.total = res.data.size
      } catch (error) {
        this.loading = false
      }
    },
    createRecordTableData(data) {
      return data.map(item => {
        let signIn = '-', signOut = '-'
        item.signs.forEach(item => {
          if (item.signType === 1) signIn = item.signAt
          if (item.signType === 2) signOut = item.signAt
        })

        return {
          key: item.id,
          id: item.id,
          visitor: item.name,
          visitorPhone: item.phoneNumber,
          carNumber: item.carNumber,
          interviewee: item.beVisitedPersonName,
          deptFullName: item.beVisitedPersonDeptFullName,
          expiryDate: `${item.visitStart} ~ ${item.visitEnd}`,
          signIn,
          signOut,
          reserved: Boolean(item.appointmentVisitorId),
          visitId: item.visitId,
          operation: {
            type: 'visitorMana.record.listDetailBtn',
            callback: this.handleVisitorDetail
          }
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.getListData()
    },

    // 查看访客详情
    async handleVisitorDetail(data) {
      // console.log('--handleVisitorDetail--', data)
      try {
        this.detailModalVisible = true
        this.detailModalLoading = true
        // 访客详情请求
        const res = (await getVisitorApplyDetail({ id: data.visitId })).data.collection[0]

        // 被访问人信息
        this.iName = res.beVisitedPersonName
        this.iOrg = res.beVisitedPersonDeptFullName
        this.visitRange = `${res.visitStart} ~ ${res.visitEnd}`
        this.visitReason = res.reason
        this.remark = res.remark
        // 当前到访人员
        const visitor = res.visitors.find(v => v.id === data.id)
        // 当前到访人员签到、签离
        let signIn, signOut
        visitor.signs.forEach(item => {
          if (item.signType === 1) signIn = item
          if (item.signType === 2) signOut = item
        })

        // this.reservedPhotoUrl = visitor.scenePhotoUrl
        // this.signInPhotoUrl = signIn ? signIn.scenePhotoUrl : ''
        this.signInPhotoUrl = visitor.scenePhotoUrl
        this.vName = visitor.name
        this.vPhone = visitor.phoneNumber
        this.vCardType = this.idType[visitor.certificationTypeCode]
        this.vIDNumber = visitor.idNumber
        this.vLicense = visitor.carNumber
        this.vSignInAt = signIn ? signIn.signAt : ''
        this.vSignInDevice = signIn ? signIn.signDeviceName : ''
        this.vSignOutAt = signOut ? signOut.signAt : ''
        this.vSignOutDevice = signOut ? signOut.signDeviceName : ''
        this.vReserved = data.reserved
        this.detailModalLoading = false

        // console.log(res.visitors)
        // 分离当前访客、同行访客
        let currentVisitor = [],
          otherVisitor = []
        if (res.visitors) {
          otherVisitor = res.visitors
          currentVisitor = otherVisitor.filter(
            (v, index, otherVisitor) => {
              if (v.id === data.id) {
                otherVisitor.splice(index, 1)
                return v
              }
            }
          )
        }
        // console.log(otherVisitor)
        // 同行访客
        this.otherVisitor = otherVisitor.map(visitor => {
          // 到访人员签到、签离
          let {
            signIn,
            signOut
          } = this.getSignInfo(visitor.signs)

          return {
            reservedPhotoUrl: visitor.scenePhotoUrl,
            signInPhotoUrl: signIn ? signIn.scenePhotoUrl : '',
            name: visitor.name,
            phone: visitor.phoneNumber,
            cardType: this.idType[visitor.certificationTypeCode],
            idNumber: visitor.idNumber,
            license: visitor.carNumber,
            signInAt: signIn ? signIn.signAt : '',
            signInDevice: signIn ? signIn.signDeviceTypeName : '',
            signOutAt: signOut ? signOut.signAt : '',
            signOutDevice: signOut ? signOut.signDeviceTypeName : ''
          }
        })
        //扩展信息
        this.exFieldValue = res.exFieldValue || {}
        // console.log(this.otherVisitor)
      } catch (error) {
        this.detailModalLoading = false
      }
    },
    getSignInfo(signs) {
      let signIn, signOut
      signs.forEach(item => {
        if (item.signType === 1) signIn = item
        if (item.signType === 2) signOut = item
      })
      return {
        signIn,
        signOut
      }
    },
    // 关闭访客详情模态框
    handleDetailModalHide() {
      // console.log('--handleDetailModalHide--')
      this.detailModalLoading = false

      this.reservedPhotoUrl = ''
      this.signInPhotoUrl = ''
      this.vName = ''
      this.vPhone = ''
      this.vCardType = ''
      this.vLicense = ''
      this.vIDNumber = ''
      this.vSignInAt = ''
      this.vSignInDevice = ''
      this.vSignOutAt = ''
      this.vSignOutDevice = ''
      this.vReserved = ''

      this.iName = ''
      this.iOrg = ''
      this.visitRange = ''
      this.visitReason = ''
      this.remark = ''
    },
    async handleExportList() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {

          this.searchDeptFullName = this.orgAutoCompletedSourceData.find(
            org => org.id === values.deptId
          ).name
          this.searchName = values.name
          this.searchFromDate = values.dateRange[0].format('YYYY-MM-DD')
          this.searchToDate = values.dateRange[1].format('YYYY-MM-DD')

          this.exportLoading = true
          downLoadFileViaAjaxPost(
            '/face/web/visit/export_visitor',
            {
              beVisitedPersonDeptFullName: this.searchDeptFullName || this.orgTreeDownSelectionData[0].fullName,
              visitStartFrom: this.searchFromDate,
              visitStartTo: this.searchToDate,
              name: this.searchName
            },
            `${this.$t('visitorMana.record.exportFilePrefix')}(${this.searchFromDate} ~ ${this.searchToDate})`,
            'xlsx',
            () => {
              this.exportLoading = false
              this.$notification.success({
                message: this.$t('visitorMana.record.exportSuccess')
              })
            }
          )
          this.exportLoading = false
        }
      })
    },
    async getSettings(){
      let _this = this
      try {
        const res = await getUserConfig()
        const {
          appointmentApplyCustomExFieldConfig
        } = res.data.collection[0]
        let exFieldConfig = {}
        if (appointmentApplyCustomExFieldConfig){
          let exFields = JSON.parse(appointmentApplyCustomExFieldConfig)
          exFields.forEach(item=>{
            exFieldConfig[item.id] = item
          })
        }
        let  newkeys = []
        let keys = Object.keys(exFieldConfig)
        keys.forEach((key)=>{
          let item = exFieldConfig[key]
          let order = item.order
          newkeys.splice(order, 0, key);
        })
        _this.exFieldConfig = exFieldConfig
        _this.exFieldKeys = newkeys
      }catch (e) {

      }
    },
    getExtValue(id){
      let config = this.exFieldConfig[id]
      let type = config.type
      let val = this.exFieldValue.hasOwnProperty(id)? this.exFieldValue[id] : undefined
      //单选
      if (type === 3){
        return  val===undefined?'无' : (val? "是" : "否")
      }
      let name = val ? val : ''
      if (type === 6){
        let enums = config.enums
        enums.forEach(item=>{
          if(item.code === val){
            name = item.name
          }
        })
        return name === '' ? '无': name
      }
      if (type === 7){
        let enums = config.enums
        let nameList = []
        enums.forEach(item=>{
          if (val && val.includes(item.code)){
            nameList.push(item.name)
          }
        })
        name = nameList.join("，")
        return  name === '' ? '无': name
      }
      return name === '' ? '无': name
    },
  }
}
</script>

<style scoped>
.loading-spin-warp {
  width: 100%;
  position: absolute;
  left: 0;
  top: 55px;
  bottom: 0;
  background-color: rgba(230, 247, 255, 0.5);
  z-index: 1;
}

.loading-spin-warp > .loading-spin {
  position: absolute;
  top: 50%;
  left: 45%;
  margin-top: -23px;
}

.desc-text-warp {
  padding-bottom: 24px;
}

.desc-text-warp .desc-title {
  display: inline-block;
  text-align: right;
  width: 100px;
  position: relative;
  color: rgba(0, 0, 0, 0.85);
}

.desc-text-warp .desc-title:after {
  content: ':';
  position: absolute;
  right: -5px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.5;
}

.desc-text-warp .desc-content {
  display: inline-block;
  width: calc(100% - 100px);
  padding-left: 15px;
  vertical-align: top;
  line-height: 1.5;
}

.desc-image-warp {
  padding-bottom: 24px;
}

.desc-image-warp .image-content {
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.desc-image-warp .image-content > img {
  max-height: 100%;
  max-width: 100%;
}

.desc-image-warp .image-title {
  display: block;
  width: 100%;
  text-align: center;
  margin-top: 5px;
}

.desc-bottom-line {
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 24px
}
</style>
